module.exports = __webpack_public_path__ + "img/P54-zh.8b484a3e.png";